// Module
var code = "<div> <div class=\"jumbotron text-center\"> <h1>{{'Page not found'|translate}}</h1> </div> <div class=\"text-center\"> <p>{{'The page you are trying to access could not be found.'|translate}}</p> </div> </div>";
// Exports
module.exports = code;